import {Controller, useForm} from 'react-hook-form'
import {useDispatch, useSelector} from 'react-redux'
import {DailySoldReportContext} from '../../context'
import {useContext, useState} from 'react'
import ReactSelect from '../../../../components/ReactSelect'
import MultipleSelect from '../../../../components/MultiSelect'
import {dataToTagSelectList} from '../../../../utils/common'
import {dataToMultiSelectOptions, formDashboardDataToFiltersValue} from '../../utils'
import {useAppSelector} from '../../../../redux/useTypedSelector'
import {setUserFilter, setSupplierFilter} from '../../../../redux/ReplenishmentActions'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import usePermission from '../../../../hook/usePermission'
import useGetJobData from '../../../jobs/hooks/useGetJobData'
import {formatDate} from '../../../../utils/date'
import Search from '../../../../components/Search'
import Import from '../../../../images/Import.png'

const DailySoldReportHeader = () => {
  const {global_user, global_suppliers} = useSelector((state: any) => state.filters)
  const {user} = useAppSelector((state) => state.auth)
  const dispatch = useDispatch()
  const {hasPermission} = usePermission()
  const {jobData, isProcessing, runTask} = useGetJobData('update_analytics_tables')

  const {
    tags,
    mappedUsers,
    isFetchingData,
    replenishment,
    tableFilters,
    selectedSkus,
    onChangeDiscontinueFilters,
    handleUserChange,
    onResetDropdownFilters,
    onApplyFilters,
    onSearch,
    isFetchingReplenishmentData,
    onDownloadCsv,
    isFetchingCsvData,
    isUserExist,
    isLoadingCsv,
    onCsvExport,
  } = useContext(DailySoldReportContext)

  const [showModal, setShowModal] = useState(false)
  const [exportShowModal, setExportShowModal] = useState(false)
  const [message, setMessage] = useState('')

  const defaultValues = {
    search: '',
    name: global_user?.value !== '' ? global_user : '',
    brands: [],
    classifications: [],
    primary_supplier: global_suppliers || [],
    tags: [],
    page: 1,
    limit: 50,
    hide_discontinued: true,
    show_zero_qty_products: true,
    no_sold_days: false,
  }

  const {control, register, getValues, reset, setValue} = useForm({
    defaultValues: defaultValues,
  })

  const onClickApplyfilter = async () => {
    const values = getValues()
    onApplyFilters(formDashboardDataToFiltersValue(values))
  }

  const onResetFilters = () => {
    reset(defaultValues)
    setValue('name', '')
    setValue('primary_supplier', [])
    dispatch(setSupplierFilter([]))
    dispatch(setUserFilter(''))
    onClickApplyfilter()
    onResetDropdownFilters()
  }

  // HANDLE USER ...
  const handleUser = (user: string) => {
    setValue('primary_supplier', [])
    setValue('classifications', [])
    setValue('brands', [])
    dispatch(setSupplierFilter([]))
    handleUserChange(user)
    if (!user) {
      dispatch(setUserFilter(''))
    } else {
      dispatch(setUserFilter(user))
    }
  }
  const handleDiscontinueFlagChange = (e: any) => {
    onChangeDiscontinueFilters(e?.target?.checked)
  }

  const onSupplierChange = (value: any) => {
    dispatch(setSupplierFilter(global_suppliers))
  }

  async function downloadCsvFile() {
    const payload = {
      filtered_skus: selectedSkus?.['skus']?.join(','),
    }
    const res: any = await onDownloadCsv(payload)
    if (res !== '') {
      setShowModal(true)
      setMessage(res)
    }
  }

  async function handleDownLoadCSV() {
    const res: any = await onCsvExport()
    if (res !== '') {
      setExportShowModal(true)
      setMessage(res)
    }
  }

  return (
    <div className='flex justify-between items-center mb-10'>
      <div className='flex items-center gap-2'>
        <div className='mt-8 w-250px'>
          <Search onSearch={onSearch} />
        </div>
        <div className='d-flex mt-10'>
          <div className='d-flex align-items-center'>
            <input
              className='form-check-input widget-9-check me-2'
              type='checkbox'
              {...register('hide_discontinued')}
              onChange={(e: any) => handleDiscontinueFlagChange(e)}
            />
            <h6 className='form-check-label mb-0'>Hide Discontinued Products</h6>
          </div>
          <div className='d-flex align-items-center ms-10'>
            <input
              className='form-check-input widget-9-check me-2'
              type='checkbox'
              {...register('show_zero_qty_products')}
            />
            <h6 className='form-check-label mb-0'>Show "0" Qty Products</h6>
          </div>
          <div className='d-flex align-items-center ms-10'>
            <input
              className='form-check-input widget-9-check me-2'
              type='checkbox'
              {...register('no_sold_days')}
            />
            <h6 className='form-check-label mb-0'>Show Not sold Products Only</h6>
          </div>
        </div>

        {tableFilters && (
          <div className='mt-10'>
            <h4 className='mb-6'>More filter</h4>
            <div className='bottom-filter-section d-flex align-items-center-1 mb-5 row'>
              <div className={`w-20 ${isUserExist ? 'd-none' : ''}`}>
                <div className='search-param'>
                  <Controller
                    name='name'
                    control={control}
                    render={({field: {value, name, onChange}}) => (
                      <ReactSelect
                        name={name}
                        value={value}
                        defaultValue={global_user?.value !== '' ? global_user : ''}
                        label={'Select User'}
                        placeholder='Select User'
                        options={mappedUsers}
                        onChange={(e: any) => {
                          onChange(e?.target?.value)
                          handleUser(e?.target?.value?.value)
                        }}
                        isLoading={isFetchingData}
                      />
                    )}
                  />
                </div>
              </div>
              <div className='w-20'>
                <div className='search-param select-2-css-placeholder'>
                  <>
                    <label className={'form-label'}>{'Primary Supplier'}</label>
                    <Controller
                      name='primary_supplier'
                      control={control}
                      render={({field: {value, onChange}}) => (
                        <MultipleSelect
                          options={dataToMultiSelectOptions(tableFilters, 'primary_supplier')}
                          handleSelected={(selectedValues) => {
                            onSupplierChange(selectedValues)
                            onChange(selectedValues)
                          }}
                          defaultValues={value}
                          hasSelectAll={false}
                          placeholder='Select Primary Supplier'
                        />
                      )}
                    />
                  </>
                </div>
              </div>

              <div className='w-20'>
                <div className='search-param select-2-css-placeholder'>
                  <>
                    <label className={'form-label'}>{'Classifications'}</label>
                    <Controller
                      name='classifications'
                      control={control}
                      render={({field: {value, onChange}}) => (
                        <MultipleSelect
                          options={dataToMultiSelectOptions(tableFilters, 'classification')}
                          handleSelected={onChange}
                          defaultValues={value}
                          hasSelectAll={false}
                          placeholder='Select Classification'
                        />
                      )}
                    />
                  </>
                </div>
              </div>
              <div className='w-20'>
                <div className='search-param select-2-css-placeholder'>
                  <>
                    <label className={'form-label'}>{'Brands'}</label>
                    <Controller
                      name='brands'
                      control={control}
                      render={({field: {value, onChange}}) => (
                        <MultipleSelect
                          options={dataToMultiSelectOptions(tableFilters, 'brand')}
                          handleSelected={onChange}
                          defaultValues={value}
                          hasSelectAll={false}
                          placeholder='Select Brand'
                        />
                      )}
                    />
                  </>
                </div>
              </div>

              <div className='w-20'>
                <div className='search-param select-2-css-placeholder'>
                  <>
                    <label className={'form-label'}>{'Tags'}</label>
                    <Controller
                      name='tags'
                      control={control}
                      render={({field: {value, onChange}}) => (
                        <MultipleSelect
                          options={dataToTagSelectList(tags)}
                          handleSelected={onChange}
                          defaultValues={value}
                          placeholder='Select Tags'
                          className='text-uppercase'
                        />
                      )}
                    />
                  </>
                </div>
              </div>

              {/* Button  */}
              <div className='d-flex justify-content-between align-items-center'>
                <div>
                  <button
                    type='button'
                    className='btn btn-outline'
                    onClick={onResetFilters}
                    disabled={isFetchingReplenishmentData}
                  >
                    Reset Filters
                  </button>
                  <button
                    className='btn btn-primary ms-3'
                    onClick={onClickApplyfilter}
                    disabled={isFetchingReplenishmentData}
                  >
                    Apply Filters
                  </button>

                  {replenishment && replenishment.length > 0 && user?.is_owner ? (
                    <button
                      type='button'
                      className='btn btn-primary ms-4'
                      onClick={downloadCsvFile}
                      disabled={isFetchingCsvData}
                    >
                      {isFetchingCsvData ? 'Downloading...' : 'Download CSV'}
                    </button>
                  ) : null}
                </div>
                <div className='d-flex align-items-center gap-5'>
                  <button
                    className='btn btn-outline'
                    onClick={handleDownLoadCSV}
                    disabled={isLoadingCsv || !replenishment?.length}
                  >
                    <div className='d-flex align-items-center'>
                      <img src={Import} alt='Import File' className='me-2 import-icon' />
                      <div className='d-flex align-items-center'>
                        {isLoadingCsv ? 'Downloading...' : 'Export Prefilled Disposable'}
                        {isLoadingCsv && (
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        )}
                      </div>
                    </div>
                  </button>
                  {hasPermission('settings_jobs', 'write') && (
                    <div className='position-relative d-flex align-items-center'>
                      <span className='me-2'>Last Sync:</span>
                      <span className='me-3'>{formatDate(jobData.last_run_end_time, false)} </span>
                      {!isProcessing && (
                        <>
                          {
                            <i
                              className='fas fa-sync cursor-pointer fs-5'
                              onClick={() => runTask('update_analytics_tables')}
                            ></i>
                          }
                        </>
                      )}
                      {isProcessing && (
                        <div className='d-flex justify-content-center'>
                          <div className='spinner-border text-success' role='status'>
                            <span className='sr-only'>Loading...</span>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <ConfirmationModal
        show={showModal}
        onClose={() => {
          setShowModal(false)
          setMessage('')
        }}
        title={'Generating Your CSV File'}
        disableAction={true}
        onAction={() => {
          setShowModal(false)
          setMessage('')
        }}
        okayBtnClass={'btn-primary'}
        body={
          <div>
            <p>We are generating the data you requested for download as a CSV file.</p>
            <p>
              This process may take a few minutes. Once complete, the CSV will be sent to your
              email: <b>{message.split(':')[1]}</b>
            </p>
          </div>
        }
      />

      <ConfirmationModal
        show={exportShowModal}
        onClose={() => {
          setExportShowModal(false)
          setMessage('')
        }}
        title={'Generating Your CSV File'}
        disableAction={true}
        onAction={() => {
          setExportShowModal(false)
          setMessage('')
        }}
        okayBtnClass={'btn-primary'}
        body={
          <div>
            <p>
              We are generating the data including all the <b>Discontinued classification </b>
              products. 
            </p>
            <p>
              This process may take a few minutes. Once complete, the CSV will be sent to your
              email: <b>{message.split(':')[1]}</b>
            </p>
          </div>
        }
      />
    </div>
  )
}

export default DailySoldReportHeader
